<template>
  <div v-if="acfLoaded" class="exhibition-single" id="exhibition">
    <div class="back-button pointer hide-sitemap xs-hide">
      <img @click="goBack" alt="Go Back to Exhibitions" src="@/assets/icon-arrow-left.svg" />
    </div>
    <div class="card border relative mx-auto">
      <div class="row clearfix flex">
        <card-block
          width="33.33"
          header="Venue"
          :content="currentExhibition.acf.venue">
          </card-block>
        <card-block
          width="33.33"
          header="Date"
          :content="exhibitionStatus(exhibition) + exhibitionDates(exhibition)">
          </card-block>
        <card-block
          width="33.33"
          header="Exhibition Type"
          :content="exhibitionCategory">
          </card-block>
      </div>
      <div v-if="currentExhibition.acf.venue_website" class="row clearfix flex">
        <card-action
          width="100"
          type="exhibitionWebsite"
          :content="currentExhibition.acf.venue_website">
          </card-action>
      </div>
    </div>

    <span v-waypoint="{
      active: true,
      callback: toggleNavIndex
    }"></span>

    <scrollactive class="z4 investigation-nav xs-hide" ref="navbar">
      <ul class="col-12 menu-items caps list-reset max-width mx-auto center hide-print">
        <li class="mx2">
          <a href="#" class="scrollactive-item is-active" v-scroll-to="'#app'">Exhibition</a></li>
        <li v-if="hasTeam" class="mx2">
          <a class="scrollactive-item" v-scroll-to="'#team'">Team</a></li>
        <li v-if="relatedInvestigations.length" class="mx2">
          <a class="scrollactive-item" v-scroll-to="'#investigations'">Investigations</a></li>
        <li v-if="press.length" class="mx2">
          <a class="scrollactive-item" v-scroll-to="'#press'">Press</a></li>
        <li v-if="recognition.length" class="mx2">
          <a class="scrollactive-item" v-scroll-to="'#recognition'">Recognition</a></li>
        <li v-if="publications.length" class="mx2">
          <a class="scrollactive-item" v-scroll-to="'#publications'">Publications</a></li>
      </ul>
    </scrollactive>

    <slider v-if="featuredMedia" :content="featuredMedia"></slider>
    <div v-else-if="featureImage" class="feature-image col-12 mb3" v-html="getImageSrcSetNonLazy(featureImage)"></div>

    <!-- Content -->
    <div v-if="hasDescription" class="content lazy-container">
      <div class="block-wrapper synopsis" v-if="currentExhibition.acf.synopsis" v-html="currentExhibition.acf.synopsis">
      </div>
      <div v-for="(block, index) in currentExhibition.acf.description.description" class="block-wrapper" :key="index" @click="handleClick">
        <h3 class="block-heading mb2" v-if="block.block_heading">{{ block.block_heading }}</h3>
        <div v-if="block.block_content.columns === '1'" class="block-content">
          <div v-html="block.block_content.column_1"></div>
        </div>
        <div v-else class="block-content two-col clearfix mxn2">
          <div v-html="block.block_content.column_1" class="block-column md-col xs-col-12 md-col-12 lg-col-6 mx-auto px0 md-px2 lg-px2 mb2 md-mb0 lg-mb0"></div>
          <div v-html="block.block_content.column_2" class="block-column md-col xs-col-12 md-col-12 lg-col-6 px0 md-px2 lg-px2"></div>
        </div>
      </div>
    </div>

    <div v-else class="exhibition sans lazy-container">
      <div class="block-wrapper">
        <div v-html="currentExhibition.acf.content"></div>
      </div>
    </div>

    <div v-if="hasTeam">
      <span id="team"></span>
      <h2 class="section-heading">Team</h2>
      <team-table
        v-if="currentExhibition.acf.curator"
        tableType="extended"
        title="Curation"
        :content="currentExhibition.acf.curator"></team-table>

      <team-table
        v-if="currentExhibition.acf.forensic_architecture_team"
        tableType="exhibition"
        title="Forensic Architecture Team"
        :content="currentExhibition.acf.forensic_architecture_team"></team-table>

      <team-table
        v-if="currentExhibition.acf.extended_team"
        tableType="extended"
        title="Extended Team"
        :content="currentExhibition.acf.extended_team"></team-table>

      <team-table
        v-if="currentExhibition.acf.collaborators"
        tableType="extended"
        title="Collaborators"
        :content="currentExhibition.acf.collaborators"></team-table>

      <team-table
        v-if="currentExhibition.acf.contributors"
        tableType="extended"
        title="Contributors"
        :content="currentExhibition.acf.contributors"></team-table>

      <team-table
        v-if="currentExhibition.acf.graphic_design"
        tableType="extended"
        title="Graphic Design"
        :content="currentExhibition.acf.graphic_design"></team-table>
      </div>

    <h2 v-if="relatedInvestigations" class="section-heading">Investigations</h2>
    <investigations-table
      id="investigations"
      v-if="relatedInvestigations"
      :content="relatedInvestigations"></investigations-table>

    <h2 v-if="press.length" class="section-heading">Press</h2>
    <press-table
      id="press"
      v-if="press.length"
      :showTitle="true"
      :content="press"></press-table>

    <h2 v-if="recognition.length" class="section-heading"></h2>
    <recognition-table
      id="recognition"
      v-if="recognition.length"
      :showTitle="true"
      :content="recognition"></recognition-table>

    <h2 v-if="publications.length" class="section-heading">Publications</h2>
    <publication-table
      id="publications"
      v-if="publications.length"
      :showDescription="false"
      :content="publications"></publication-table>

    <!-- TODO: FOOTER BAR/RELATED -->
    <footer-bar v-if="false" :show-media="galleryItems"></footer-bar>

    <transition name="fade">
      <router-view name="mediaPanel" :exhibition="exhibition"></router-view>
      <router-view name="gallery" :galleryItems="galleryItems"></router-view>
    </transition>

  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { exhibitionDates, exhibitionStatus, getRelated, getImageSrcSetNonLazy } from '@/utils.js'
import dayjs from 'dayjs'
import CardBlock from '@/components/CardBlock'
import CardAction from '@/components/CardAction'
import Slider from '@/components/Slider'
import InvestigationsTable from '@/components/InvestigationsTable'
import PublicationTable from '@/components/PublicationTable'
import TeamTable from '@/components/TeamTable'
import PressTable from '@/components/PressTable'
import RecognitionTable from '@/components/RecognitionTable'
import FooterBar from '@/components/FooterBar'

export default {

  name: 'Exhibition',

  data () {
    return {
      slug: this.$route.params.slug,
      lazyContainer: this.lazyLoad({
        elements_selector: ".lazy-container img"
      })
    }
  },

  metaInfo () {
    return {
      title: this.getMeta.title.replace('&nbsp;',' '),
      meta: [
        { name: 'og:title', content: this.getMeta.title },
        { name: 'twitter:title', content: this.getMeta.title },
        { name: 'og:image', content: this.getMeta.image },
        { name: 'twitter:image', content: this.getMeta.image },
        { name: 'og:url', content: `${window.location.origin}/${this.$route.fullPath}` },
        { name: 'og:type', content: 'website' },
        { name: 'og:description', content: this.getMeta.description },
        { name: 'twitter:description', content: this.getMeta.description }
      ]
    }
  },

  components: {
    CardAction,
    CardBlock,
    FooterBar,
    InvestigationsTable,
    PublicationTable,
    PressTable,
    RecognitionTable,
    Slider,
    TeamTable
  },
  computed: {
    ...mapState([
      'investigations',
      'exhibitions'
    ]),
    ...mapGetters([
      'currentExhibition',
      'getExhibitionBySlug'
    ]),
    hasDescription () {
      return this.currentExhibition.acf.description.description
    },
    getMeta () {
      if (this.currentExhibition) {
        return {
          title: this.currentExhibition.title,
          image: this.currentExhibition.feature_image.link,
          description: `${this.currentExhibition.venue} → ${this.exhibitionDates(this.currentExhibition)}`
        }
      } else {
        return false
      }
    },
    acfLoaded () {
      return this.currentExhibition && this.currentExhibition.hasOwnProperty('acf')
    },
    recognition () {
      return this.getRelated(this.currentExhibition, 'recognition')
    },
    exhibition () {
      return this.getExhibitionBySlug(this.slug)
    },
    featuredMedia () {
      if (this.currentExhibition.acf.featured_media) {
        return this.currentExhibition.acf.featured_media
      } else {
        return false
      }
    },
    featureImage () {
      if (this.currentExhibition.acf.featured.feature_image) {
        return this.currentExhibition.acf.featured.feature_image
      } else {
        return false
      }
    },
    galleryItems () {
      if (Object.keys(this.currentExhibition.acf).length !== 0 &&
        Object.keys(this.currentExhibition.acf.media).length !== 0) {
        return this.currentExhibition.acf.media.filter(item => {
          return item.type === 'image'
        })
      } else {
        return false
      }
    },
    exhibitionCategory () {
      let categories = this.currentExhibition.acf.category.filter(cat => {
        return cat.name !== 'Featured'
      })
      return categories[0].name
    },
    hasTeam () {
      return (this.currentExhibition.acf.forensic_architecture_team || this.currentExhibition.acf.extended_team)
    },
    relatedInvestigations () {
      let relatedInvestigations = this.getRelated(this.currentExhibition, 'investigation')

      if (relatedInvestigations) {
        return relatedInvestigations.map(x => {
          return this.investigations.find(inv => {
            return inv.id === x.ID
          })
        })
      } else {
        return false
      }
    },
    press () {
      let items = this.getRelated(this.currentExhibition, 'press')

      if (items) {
        items = items.sort(function (a, b) { return dayjs(a.date).isBefore(b.date)
      })
      }
      return items
    },
    publications () {
      return this.getRelated(this.currentExhibition, 'publication')
    }
  },
  mounted () {
    this.updated()
  },
  methods: {
    ...mapActions([
      'getExhibition'
    ]),
    exhibitionDates,
    exhibitionStatus,
    getImageSrcSetNonLazy,
    getRelated,
    goBack () {
      if (window.from.name === 'Exhibitions') {
        this.$router.go(-1)
      } else {
        this.$router.push({ name: 'Exhibitions' })
      }
    },
    toggleNavIndex ({going}) {
      if (this.$refs.navbar) {
        let nav = this.$refs.navbar.$el
        if (going === 'out') {
          nav.classList.add('ontop')
        } else {
          nav.classList.remove('ontop')
        }
      }
    },
    updated: function () {
      this.$nextTick(function () {
        this.lazyContainer.update()
      })
    },
  },
  beforeRouteUpdate (to, from, next) {
    this.getExhibition(to.params.slug).then(() => next())
  },
  watch: {
    acfLoaded () {
      this.updated()
    }
  } 
}
</script>

<style>
  #exhibition {
    .caption {
      font-size: var(--font-size-xs);
    }

    img.cursor-zoom-in {
      cursor: default;
    }
  }
  .ontop {
    z-index: 10;
  }
  .feature-image {
    >div {
      width: 100%;
      height: 40vw;
      overflow: hidden;
    }

    img {
      object-fit: cover;
      height: 100%;
    }
  }
</style>
